const SET_APP_FIELD = 'app/SET_APP_FIELD'
const SET_APP_FIELDS = 'app/SET_APP_FIELDS'
const SET_FOOTER_FIELD = 'app/SET_FOOTER_FIELD'
const SET_ASK_EXPERT_POPUP = 'app/SET_ASK_EXPERT_POPUP'

export { SET_APP_FIELD, SET_APP_FIELDS, SET_FOOTER_FIELD, SET_ASK_EXPERT_POPUP }
